<template>
  <div >




    <Section background="white"  class="image-bg"
             :style="{'background-image': `url(${require('../../assets/images/content/jesus_main.png')})`}"
    >

      <!--<nav-bar dark></nav-bar>-->
<!--      <div class=" main-heading heading-line pt-1">-->
<!--      </div>-->

       <div class=" main-heading heading-line" style=" width: 100%;" >

          <!--<v-container fluid style="color:#ffffff; background-color:rgba(43,43,43,0.4); width: 100%;">-->

          <!--<v-container fluid style="color:#ffffff;  width: 100%;">-->
          <!--   <div class="center display-2">Namihira Ministries</div>-->
          <!--   <div class="center title">Preparing for Jesus' Second Coming</div>-->

          <!--</v-container>-->

       </div>
    </Section>




     <div class="main-content-container">
        <h1> ようこそ！</h1>
        <p style = "text-align:justify">
           波平伝道は、福音の良きニュースを宣言し、そして、神の愛を世界に分け与えることに献身しています。   聖書の預言は、終末の事件を指し示しています。
           そして、それらの預言は急速に成就しています。人々にその預言の知識を知らせ、来たるべき世の終りの事件と、キリストの再臨に関して警告することを唯一の目的としています。
        </p>
     </div>













     <!--<div style="margin-top: 20px">-->

     <!--   <v-row style="flex-wrap: nowrap" no-gutters>-->
     <!--      <v-col class="matrix-col">-->

     <!--         <img class="matrix-img"-->
     <!--             src="../../assets/images/content/radio_mic.jpg">-->
     <!--         <div class="matrix-col-heading">-->
     <!--            「聖書を生きる」ラジオ-->
     <!--            &lt;!&ndash;Living the Bible&ndash;&gt;-->
     <!--         </div>-->
     <!--      </v-col>-->


     <!--      <div class="matrix-col-spacer"/>-->
     <!--      -->
     <!--      <div class="matrix-col-spacer"/>-->


     <!--      <v-col class="matrix-col">-->

     <!--         <img class="matrix-img"-->
     <!--              src="../../assets/images/content/namihira_patient.jpg">-->
     <!--         <div class="matrix-col-heading">-->
     <!--            &lt;!&ndash;Dr. Namihira's Story&ndash;&gt;-->
     <!--            波平医師の物語-->
     <!--         </div>-->
     <!--      </v-col>-->


     <!--      <div class="matrix-col-spacer"/>-->

     <!--      <v-col class="matrix-col">-->

     <!--         <img class="matrix-img" style="max-height: 125px; width: auto"-->
     <!--              src="./images/book.jpg">-->
     <!--         <div class="matrix-col-heading">-->
     <!--            &lt;!&ndash;Namihira book&ndash;&gt;-->
     <!--            「松葉杖の医師」をお読みください。-->
     <!--         </div>-->
     <!--      </v-col>-->




     <!--   </v-row>-->


     <!--</div>-->

















     <v-container>
        <v-row>
           <v-col cols="4">
              <v-card class="container-card"
                      @mouseover="mouseover_ltb=true"
                      @mouseleave="mouseover_ltb=false"
              >
                 <div v-if="mouseover_ltb" class="btn-container">
                    <v-btn  rounded dark min-width="150" color="var(--color-primary)" to="/jp/radio" >
                       <!--Listen-->
                       聞く
                    </v-btn>
                 </div>

                 <div class="card-heading">
                    <!--Living the Bible-->
                    主の来臨に備えて
                    <!--<hr>-->
                 </div>



                 <div class="image-container flex-center">
                    <img class="image" src="../../assets/images/content/radio_mic.jpg">
                 </div>
              </v-card>
           </v-col>



           <v-col cols="4">
              <v-card class="container-card"
                      @mouseover="mouseover_music=true"
                      @mouseleave="mouseover_music=false"
              >
                 <div v-if="mouseover_music" class="btn-container">
                    <v-btn  rounded dark min-width="150" color="var(--color-primary)" to="/music">
                       <!--Listen-->
                       聞く
                    </v-btn>
                 </div>

                 <div class="card-heading">
                    <!--Music-->
                    音楽
                 </div>

                 <div class="image-container flex-center">
                    <img class="image" src="../../assets/images/content/cd_1_front.jpg">
                 </div>
              </v-card>
           </v-col>

           <v-col cols="4">
              <v-card class="container-card"
                      @mouseover="mouseover_story=true"
                      @mouseleave="mouseover_story=false"
              >
                 <div v-if="mouseover_story" class="btn-container">
                    <v-btn  rounded dark min-width="150" color="var(--color-primary)" to='/jp/book' class="mb-5">
                       <!--Read-->
                       読む
                    </v-btn>
                    <v-btn  rounded dark min-width="150" color="var(--color-primary)" to="/jp/video/namihira-story" >
                       <!--Watch-->
                       見る
                    </v-btn>
                 </div>

                 <div class="card-heading">
                    <!--Dr. Namihira's Story-->
                    松葉杖の医師

                 </div>



                 <div class="image-container flex-center">
                    <img class="image" src="../../assets/images/content/namihira_patient.jpg">
                 </div>
              </v-card>
           </v-col>
        </v-row>


     </v-container>



     <div style="display: flex; justify-content: center; padding-bottom: 20px">
        <v-card class="container-card"
                style="display: flex; flex-direction: column; width: 50%"
        >
           <div class="card-heading">
              <!--Connect with Us-->
              私達との触れ合い
           </div>

           <div style="flex: 1 0; display: flex; flex-wrap: wrap; justify-content: center; align-items: center; margin-top: -70px">

              <a href="https://www.youtube.com/channel/UCQNtti1Lb3sD_RXbmitiWDQ" target="_blank">
                 <img class="image-sub" src="../../assets/images/logo/youtube.png" style="height: 40px">
              </a>
              <a href="https://www.facebook.com/Namihira-Ministries-101775942072802" target="_blank">
                 <img class="image-sub" src="../../assets/images/logo/facebook.png" style="height: 50px">
              </a>

              <router-link to="/jp/contact-us">
                 <img class="image-sub" src="../../assets/images/logo/email.png" style="height: 60px">
              </router-link>

           </div>
        </v-card>
     </div>



  </div>

</template>






<style scoped lang="css">

.container-card{
    background-color: #D6E4F0;
    min-height: 250px;
}


.image-container{
    width: 100%;
    padding:0 10px 10px 10px;
}

.image{
    display: block;
    /*width: 100%;*/
    /*height: auto;*/
    height: 172px;

    border-radius: 5px;
    max-width: 100%;
}


.image-sub{
    width: auto;
    height: 50px;
    margin-left: 10px;
    margin-right: 10px;
}

hr{
    margin-top: 5px;
    margin-bottom: 5px;
    border-top:  1px solid #9a9a9a;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
}

.card-heading {
    /*margin-top: 10px;*/
    font-size: 16pt;
    font-weight: 600;
    color: var(--color-headers);
    padding: 10px;
    text-align: center;
    height: 50px;
}



.btn-container{
    position: absolute;
    margin-top: 40px;
    height: calc(100% - 40px);
    /*border: 2px gray solid;*/
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.matrix-col-heading{
    margin-top: 10px;
    font-size: 14pt;
    font-weight: 500;
    color: var(--color-headers);
}

.matrix-col{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    /*margin: 5px;*/
    background-color: var(--color-bg1);
    /*border-radius: 5px;*/
}

.matrix-img{
    /*border-radius: 5px;*/
    width: 200px;
}

.matrix-col-spacer{
    width: 5px;
}









  /*.image-bg{*/
  /*     background-size: cover;*/
  /*     background-position: center;*/
  /*  height: 300px;*/
  /*   }*/


  /*.main-heading{*/
  /*  height: 200px;*/
  /*  display: flex;*/
  /*  align-items: center;*/
  /*  justify-content: center;*/

  /*  }*/


  /*.heading-line{*/
  /*  text-align: center;*/

  /*}*/


  .section-heading{
    font-size: 3em;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    text-align: center;

  }


  .section-sub-heading {
    font-size: 2em;
    font-weight: normal;
  }


  .main-text{
     font-size: 16pt;
  }



</style>


<script>
// @ is an alias to /src
import Section from '@/components/Section.vue'
import Contact from '@/components/ContactForm.vue'
import navBar from '@/components/navBar.vue'
import location from '@/components/location.vue'

// import VueYoutube from 'vue-youtube'
import VuePlayerPlugin, { Player } from 'vue-youtube-iframe-api';

import Vue from 'vue'
Vue.use(VuePlayerPlugin);

export default {
  name: 'home',
  components: {navBar, Section, },
   data(){return {
      dialog_video: false,
      yt_vars: {},

      mouseover_ltb: false,
      mouseover_health: false,
      mouseover_music: false,
      mouseover_story: false,

   }},


   methods:{
      track (eventLabel, category='SiteNavigation') {
         console.log(eventLabel);
         this.$gtag.event('ButtonClick', {
            'event_category': category,
            'event_label': eventLabel,
         })
      },

      close_video_dialog(){
         this.dialog_video = false;
         this.stopPlayingVideo();
      },


      stopPlayingVideo(){
         this.$refs.youtube.player.stopVideo();
      }
   },

   computed:{
     slide_ratio(){

        if (['xs'].includes(this.$vuetify.breakpoint.name)){
           return 0.7;
        }

        else if (['sm'].includes(this.$vuetify.breakpoint.name)){
           return 0.5;
        }
        else {
           return 0.3;
        }
     }
   }


}
</script>
